export enum ReliabilityBeforePoolVendorType {
  Oem = 1,
  RepairStation = 2,
  TtShop = 3,
}

export const ReliabilityBeforePoolVendorTypeChoices = [
  { key: "OEM", value: ReliabilityBeforePoolVendorType.Oem },
  { key: "REPAIR STATION", value: ReliabilityBeforePoolVendorType.RepairStation },
  { key: "TT SHOP", value: ReliabilityBeforePoolVendorType.TtShop },
];
